import {
  Cloud, Mail, Shield, Database, Users, Phone, Wifi, Smartphone,
  FileText, Image as ImageIcon, Video, Music, BookOpen, Box,
  Briefcase, BarChart3, Globe, Server, Lock, Key, Layers,
  Monitor, MessageSquare, Sparkles, Building2, Search, Headphones,
  Workflow, type LucideIcon
} from 'lucide-react';

// Category → Icon mapping (lucide-react icons)
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  // Microsoft
  'Microsoft 365': Briefcase,
  'Office 365': FileText,
  'Exchange Online': Mail,
  'Security': Shield,
  'Cloud': Cloud,
  'Power Platform': BarChart3,
  'Project & Visio': Workflow,
  'SharePoint & OneDrive': Database,
  'Teams & Communication': MessageSquare,
  'Windows': Monitor,
  'Windows 365': Monitor,
  'Dynamics 365': Building2,
  'EMS & Intune': Lock,
  // Adobe
  'Creative Suite': Sparkles,
  'Design': ImageIcon,
  'Video & Audio': Video,
  'Document': FileText,
  'Photography': ImageIcon,
  'Web': Globe,
  'Publishing': BookOpen,
  'eLearning': BookOpen,
  '3D': Box,
  'Server': Server,
  'AI Credits': Sparkles,
  // Kaspersky
  'Endpoint Security': Shield,
  'Small Business': Briefcase,
  'Total Security': Lock,
  'Detection & Response': Search,
  'Management': Layers,
  'Server Security': Server,
  // 3CX
  'Phone System': Phone,
  'SBC': Server,
  'Hosted': Cloud,
  'Add-on': Headphones,
  // Ekahau
  'Wi-Fi Design': Wifi,
  'Site Survey': Wifi,
  'Wi-Fi Suite': Wifi,
  'Hardware': Smartphone,
  'Analysis': BarChart3,
  'Cloud Platform': Cloud,
};

// Brand → Logo path mapping
const BRAND_LOGOS: Record<string, string> = {
  'Microsoft': '/brands/microsoft.svg',
  'Adobe': '/brands/adobe.svg',
  'Kaspersky': '/brands/kaspersky.svg',
  '3CX': '/brands/3cx.svg',
  'Ekahau': '/brands/ekahau.svg',
};

// Brand → Gradient mapping
const BRAND_GRADIENTS: Record<string, string> = {
  'Microsoft': 'linear-gradient(135deg, #0078D4 0%, #002050 100%)',
  'Adobe': 'linear-gradient(135deg, #FA0F00 0%, #8B0000 100%)',
  'Kaspersky': 'linear-gradient(135deg, #006D5C 0%, #003D33 100%)',
  '3CX': 'linear-gradient(135deg, #0A8FDC 0%, #024A75 100%)',
  'Ekahau': 'linear-gradient(135deg, #E8500E 0%, #8B2D04 100%)',
};

export function getCategoryIcon(category: string): LucideIcon {
  return CATEGORY_ICONS[category] || Key;
}

export function getBrandLogo(brand: string): string {
  return BRAND_LOGOS[brand] || '';
}

export function getBrandGradient(brand: string): string {
  return BRAND_GRADIENTS[brand] || 'linear-gradient(135deg, #0A1128 0%, #1a2952 100%)';
}
